/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState = [
    {
        id: 1,
        il_opus_reference_id: '',
        sub_id: '',
        il_type: '',
        content: '',
        todo_status: '',
        registered_by: '',
        modified_on: null,
    },
];

const aexCommentUpdateSlice = createSlice({
    name: 'aexCommentUpdateForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        addComment: (state, action) => {
            addUniqueById(state, action.payload);
        },
        setCommentUpdateData: (state, action) => {
            const updatedObject = action.payload;
            const { id } = updatedObject;
            const item = state.find((item) => item.id === id);
            if (item) {
                Object.entries(updatedObject).forEach(([key, value]) => {
                    if (key !== 'id') {
                        item[key] = value;
                    }
                });
            }
        },
        deleteComment: (state, action) => {
            const deletedId = action.payload;
            return state.filter((item) => item.id !== deletedId);
        },
        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const { setFormData, resetFormData, addComment, setCommentUpdateData, deleteComment } =
    aexCommentUpdateSlice.actions;
export default aexCommentUpdateSlice.reducer;
